import { useEffect } from "react";

import Swal from "sweetalert2";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

function DialogBox({ showDialog, cancelNavigation, confirmNavigation }) {
  function createSweetAlert() {
    Swal.fire({
      title: `Warning`,
      html: `You are about to Navigate to another Page. </br> If you proceed any unsaved information will be lost.`,
      showDenyButton: true,
      showConfirmButton: true,
      confirmButtonText: "Procced",
      denyButtonText: "Cancel",
      icon: "warning",
      confirmButtonColor: "#87cb16",
      denyButtonColor: "#ff4a55",
    }).then(async (result) => {
      if (result.isConfirmed) {
        confirmNavigation();
      } else {
        cancelNavigation();
      }
    });
  }

  useEffect(() => {
    if (showDialog) createSweetAlert();
  }, [showDialog]);

  //   return (
  //     <Modal show={showDialog}>
  //       <Modal.Header>
  //         <Modal.Title>Warning</Modal.Title>
  //       </Modal.Header>
  //       <Modal.Body>
  //         <b>There are some changes?</b>
  //         <br /> Are you sure you want to navigate!!!!
  //       </Modal.Body>
  //       <Modal.Footer>
  //         <Button variant="primary" onClick={cancelNavigation}>
  //           No
  //         </Button>
  //         <Button variant="danger" onClick={confirmNavigation}>
  //           Yes
  //         </Button>
  //       </Modal.Footer>
  //     </Modal>
  //   );
}

// Typechecking props of the CreateTemplate
DialogBox.propTypes = {
  showDialog: PropTypes.bool,
  cancelNavigation: PropTypes.func,
  confirmNavigation: PropTypes.func,
};

export default DialogBox;
